import { CheckCircle, CircleHalf, MinusCircle, Tag, WarningCircle } from '@phosphor-icons/react'

// Traduce los estados del control diario recibidos del API a etiquetas en español.
export const STATUS_LABELS = {
  unsettled: 'Sin liquidar',
  partially_settled: 'Liquidado parcialmente',
  settled: 'Liquidado',
  no_charges: 'Sin cobros'
}

// Define la variante visual de AppChip para cada estado del control diario.
export const STATUS_VARIANTS = {
  unsettled: 'danger',
  partially_settled: 'warning',
  settled: 'success',
  no_charges: 'neutral'
}

// Opciones del filtro de control diario: todos y cada estado.
export const STATUS_OPTIONS = [
  { value: 'all', label: 'Todos' },
  ...Object.entries(STATUS_LABELS).map(([value, label]) => ({ value, label }))
]

// Tarjetas del resumen diario: estado, etiqueta, ícono y tono visual.
export const DAILY_CONTROL_TILES = [
  { status: 'unsettled', label: 'Usuarios sin liquidar', icon: WarningCircle, tone: 'danger' },
  { status: 'partially_settled', label: 'Usuarios liquidados parcialmente', icon: CircleHalf },
  { status: 'settled', label: 'Usuarios liquidados', icon: CheckCircle },
  { status: 'no_charges', label: 'Usuarios sin cobros', icon: MinusCircle }
]

// Textos del listado, los filtros, la descarga y el resumen del control diario.
export const DAILY_CONTROL_TEXT = {
  ARIA_LABEL: 'Control diario de liquidaciones',
  FILTER_TITLE: 'Filtrar usuarios',
  NOTICE: 'Se muestran los cobros registrados en la fecha seleccionada',
  SEARCH_PLACEHOLDER: 'Buscar por código o nombre de usuario...',
  EXPORT: 'Descargar tabla en pantalla',
  SUMMARY_ARIA_LABEL: 'Resumen del día',
  UPDATING: 'Actualizando indicadores',
  TOTAL_USERS: 'Total de usuarios',
  NO_CHARGES: 'Sin cobros en el día',
  COLLECTED: 'cobrados',
  SETTLED: 'liquidados',
  PENDING: 'pendientes',
  TABLE_ARIA_LABEL: 'Control diario de usuarios',
  PAGINATION_ARIA_LABEL: 'Paginación de control diario',
  ITEM_LABEL: 'usuarios',
  MISSING_VALUE: '-',
  EXPAND_USER: (name) => `Ver cobros de ${name}`
}

// Tamaño de página, ancho mínimo y altura de carga del listado diario.
export const DAILY_CONTROL_CONFIG = {
  PAGE_SIZE: 25,
  PAGINATION_THRESHOLD: 10,
  ROW_KEY: 'user_uid',
  EXPANDED_COLUMN_OFFSET: 1,
  MIN_WIDTH: 1280,
  LOADING_MIN_HEIGHT: '320px'
}

// Títulos y descripciones de la tabla cuando el día no tiene cobros o los filtros no tienen resultados.
export const DAILY_CONTROL_EMPTY_TEXT = {
  NO_CHARGES: {
    TITLE: 'Sin cobros registrados',
    DESCRIPTION: 'No se registraron cobros en este día. Selecciona otra fecha para consultar.'
  },
  NO_RESULTS: {
    TITLE: 'Sin resultados',
    DESCRIPTION: 'No hay usuarios que coincidan con la búsqueda y los filtros aplicados.'
  }
}

// Estilo numérico compartido por las columnas ordenables del resumen.
export const DAILY_CONTROL_NUMERIC_CELL_SX = { fontVariantNumeric: 'tabular-nums' }

// Columnas fijas del control diario; el componente incorpora el renderizado de cada celda.
export const DAILY_CONTROL_COLUMNS = [
  { key: 'expand', label: 'Ampliar', align: 'center', width: 90 },
  { key: 'user_uid', label: 'Usuario', width: '26%' },
  {
    key: 'charges_count',
    label: 'Cobros',
    width: 100,
    sortable: true,
    align: 'right',
    cellSx: DAILY_CONTROL_NUMERIC_CELL_SX
  },
  {
    key: 'collected_amount',
    label: 'Monto cobrado',
    sortable: true,
    align: 'right',
    cellSx: DAILY_CONTROL_NUMERIC_CELL_SX
  },
  {
    key: 'pending_charges_count',
    label: 'Cobros sin liquidar',
    sortable: true,
    align: 'right',
    cellSx: DAILY_CONTROL_NUMERIC_CELL_SX
  },
  {
    key: 'pending_amount',
    label: 'Monto pendiente',
    sortable: true,
    align: 'right',
    cellSx: DAILY_CONTROL_NUMERIC_CELL_SX
  },
  { key: 'status', label: 'Liquidación', sortable: true }
]

// Configuración del filtro de liquidación con selección única y aplicación inmediata.
export const DAILY_CONTROL_FILTERS = [
  {
    key: 'status',
    label: 'Liquidación',
    icon: Tag,
    options: STATUS_OPTIONS,
    singleSelect: true,
    alwaysInline: true,
    showSearch: false
  }
]

// Valores iniciales de los filtros utilizados en la URL y las consultas del control diario.
export const DEFAULT_FILTERS = {
  date: null,
  q: '',
  status: 'all',
  sort_by: null,
  sort_direction: 'desc',
  page: 1,
  per_page: DAILY_CONTROL_CONFIG.PAGE_SIZE
}
